import React, { ChangeEvent } from 'react';

import './file-chooser.scss';

export interface Props {
  hint?: string;
  icon?: string;
  iconSize?: string;
  minHeight?: string;
  multiple?: boolean;
  invalid?: boolean;
  onChoose?: (files: FileList | File) => void;
}

export default class FileChooser extends React.Component<Props> {

  private static counter = 0;
  protected static defaultProps = { invalid: false }

  protected inputId: string;
  protected elementId: string;

  state = {
    filename: this.props.hint ?? 'فایل را انتخاب کنید',
    invalid: this.props.invalid
  }

  static getDerivedStateFromProps(props: Props, state: any) {
    if (state.invalid !== props.invalid) {
      return { invalid: props.invalid }
    }
    return null
  }

  constructor(props: any) {
    super(props);
    FileChooser.counter++;
    this.inputId = 'input-id-' + FileChooser.counter;
    this.elementId = 'file-chooser-' + FileChooser.counter;
  }

  render() {
    return (
      <div id={this.elementId} className={'file-chooser-component' + (this.state.invalid ? ' is-invalid' : '')}>
        <input id={this.inputId} type="file" hidden onChange={this.onChange} multiple={this.props.multiple} />
        <label htmlFor={this.inputId} className="chooser-box" style={{ minHeight: this.props.minHeight ?? '250px' }}>
          <i
            style={{ fontSize: this.props.iconSize ?? '3.5rem' }}
            className={(this.props.icon ?? 'fal fa-file') + ' file-chooser-icon'}
          ></i>
          <span className="filename">{this.state.filename}</span>
        </label>
      </div>
    );
  }

  private onChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files.length === 0) {
      return event.preventDefault();
    }
    const files = event.target.files;
    const { onChoose, multiple } = this.props;
    if (onChoose) {
      onChoose(multiple ? files : files[0]);
      this.setState({
        filename: this.extractFilename(files)
      })
    }
  }

  private extractFilename = (files: FileList) => {
    const multiple = this.props.multiple;
    if (!multiple) {
      return files[0].name;
    }
    const names = [];
    for (let i = 0; i < files.length; i++) {
      names.push(files[i].name);
    }
    return names.join(', ');
  }

}
